import { SupplierApprovePriceStateEnum, SupplierPriceStateEnum } from "@/types/purchase";
import { isNull } from "lodash";
import { useTranslation } from "react-i18next";

const usePriceStatus = () => {

  const { t } = useTranslation();

  const getProductPriceStatus = (status: SupplierPriceStateEnum) => {
    const statusMap = {
      [SupplierPriceStateEnum.UN_PRICED]: {
        title: t("requirement.unPriced"),
        color: "#2db7f5",
      },
      [SupplierPriceStateEnum.PRICED]: {
        title: t("requirement.resolved"),
        color: "success"
      }
    }

    return statusMap[status]
  }

  const getSupplierPriceStatus = (status: SupplierApprovePriceStateEnum | null) => {
    if (isNull(status)) return {
      title: t("requirement.unApprove"),
      color: "#2db7f5",
    }
    const statusMap = {
      [SupplierApprovePriceStateEnum.RESOLVED]: {
        title: t("requirement.approved"),
        color: "success"
      },
      [SupplierApprovePriceStateEnum.REJECTED]: {
        title: t("requirement.rejected"),
        color: "#ff5500"
      },
    }

    return statusMap[status]
  }

  return { getProductPriceStatus, getSupplierPriceStatus }
}

export default usePriceStatus;